const fieldsToKeep = [
    'name',
    'username',
    'is_verified_badge',
    'is_document_verified',
    'total_cards',
    'id',
    'is_email_verified',
    'user_type',
    'phone_2fa_enabled',
    'email',
    'unique_id',
    'mobile',
    'cover',
    'picture'
];

export {
    fieldsToKeep
}
